module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAyCAMAAAB8gJvdAAAAVFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAU4H24AAAAG3RSTlMA9gwE8es3LcCzpk1BFdPPyZdb5NqYWjInJBz6mHTyAAAAi0lEQVQ4y73UORKDMBBEURlrARtb2Oz0/e9JolCaFlVTdPoSaYJvCjuiN+V9Jlhf1i8AGyQFXJAUiDltYtJxz+mQ1G2ihuvaVqldRfWX9dlV6aPX1ledvpXVzKL+kLaI+mfKmTt/Gv8YP4u+93nv7vFSNppWy1fZXcj7oOWbIeEi2SPRJMllwSa5PwHVKyfrRezujgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/alpineComponents/horizontalScroller/back-chevron.png
// module id = 303
// module chunks = 0